import { FadeUp } from "@/components/motion/Reveal";
import { SKILLS, TOOLS, ADDITIONAL_EXPERIENCE } from "@/data/content";

const Skills = () => {
  return (
    <section id="skills" data-testid="capabilities-section" className="border-t border-line bg-surface">
      <div className="mx-auto max-w-[1600px] scroll-mt-24 px-6 py-24 md:px-12 md:py-36">
        <FadeUp className="mb-14 max-w-3xl">
          <p className="mb-4 font-mono text-[12px] uppercase tracking-[0.2em] text-signal">/ Skills</p>
          <h2 className="font-display text-4xl font-semibold uppercase leading-[0.9] tracking-tightest text-chalk sm:text-5xl md:text-6xl">
            What I can do
            <br />
            <span className="text-outline-signal">for your team</span>
          </h2>
          <p className="mt-6 max-w-xl text-[15px] leading-[1.65] text-ash md:text-base">
            The skills I&apos;ve sharpened building brands and products — the same ones I&apos;ll bring to your
            projects.
          </p>
        </FadeUp>

        {/* Numbered skill grid */}
        <div className="grid grid-cols-1 border-t border-line sm:grid-cols-2 lg:grid-cols-3">
          {SKILLS.map((skill, i) => (
            <FadeUp
              key={skill}
              delay={(i % 3) * 0.05}
              className="group flex min-h-[64px] items-center justify-between border-b border-line px-1 py-6 transition-colors duration-300 hover:bg-white/[0.02] sm:px-6"
            >
              <div className="flex items-baseline gap-5">
                <span className="font-mono text-[13px] text-signal">{String(i + 1).padStart(2, "0")}</span>
                <span className="font-display text-xl font-medium tracking-tight text-chalk transition-colors duration-300 group-hover:text-signal md:text-2xl">
                  {skill}
                </span>
              </div>
              <span className="h-2 w-2 rounded-full bg-line transition-colors duration-300 group-hover:bg-signal" />
            </FadeUp>
          ))}
        </div>

        {/* Additional experience */}
        <FadeUp className="mt-10">
          <p className="mb-2 font-mono text-[12px] uppercase tracking-[0.2em] text-ash">Additional Experience</p>
          <p className="text-[15px] leading-[1.6] text-chalk/85">{ADDITIONAL_EXPERIENCE}</p>
        </FadeUp>

        {/* Tools */}
        <FadeUp className="mt-12">
          <p className="mb-5 font-mono text-[12px] uppercase tracking-[0.2em] text-ash">Tools I work in</p>
          <div className="flex flex-wrap gap-3">
            {TOOLS.map((t) => (
              <span
                key={t}
                className="inline-flex items-center gap-3 rounded-full border border-line px-5 py-3 font-mono text-[12px] uppercase tracking-[0.14em] text-chalk transition-colors duration-300 hover:border-signal hover:text-signal"
              >
                <span className="h-1.5 w-1.5 rounded-full bg-signal" />
                {t}
              </span>
            ))}
          </div>
        </FadeUp>
      </div>
    </section>
  );
};

export default Skills;
